import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "16_ellipse.svg",
  "use": "16_ellipse.svg-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"16_ellipse.svg\"><rect width=\"16\" height=\"16\" style=\"fill:none\" /><ellipse cx=\"7.5\" cy=\"7.5\" rx=\"7\" ry=\"6\" style=\"fill:#fafafa;stroke:#3a3a38;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.9676361351404158px\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol